import { render, staticRenderFns } from "./ProjectStatus.vue?vue&type=template&id=04f618a9&"
import script from "./ProjectStatus.vue?vue&type=script&lang=js&"
export * from "./ProjectStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports